var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnColorPicker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theming",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Copy-3",
    transform: "translate(-351.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(177.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(168.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1716375,5.227775 C6.1716375,5.227775 4.193,7.2064125 2.8987,8.500625 C2.1776125,9.2218 1.6338,10.1005625 1.310225,11.0677 C1.310225,11.0677 1.310225,11.0677875 1.3101375,11.067875 C1.0964625,11.706625 0.815325,12.3207 0.47145,12.8998625 C0.4297125,12.9702125 0.3866625,13.042575 0.3430875,13.116075 C0.2361625,13.2960625 0.2673125,13.525925 0.41825,13.671 C0.5691,13.816075 0.8000125,13.838125 0.975625,13.7242875 C1.0387125,13.6833375 1.1011,13.6429125 1.16235,13.6031875 C1.814225,13.1805625 2.5221,12.8513875 3.265325,12.6252875 C3.2655,12.6252 3.2655875,12.6252 3.2657625,12.6251125 C4.1841625,12.345725 5.0196125,11.844525 5.69835,11.1657875 C6.9533625,9.910775 8.904,7.9601375 8.904,7.9601375",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.904,7.9601375 C8.904,7.9601375 11.4200625,5.444075 13.0437125,3.820425 C13.78615,3.0779875 13.78615,1.87425 13.0437125,1.131725 C13.0291,1.1172 13.014575,1.102675 13.00005,1.0880625 C12.257525,0.345625 11.0537875,0.345625 10.31135,1.0880625 C8.6877,2.7117125 6.1716375,5.227775 6.1716375,5.227775 L8.904,7.9601375 Z",
    id: "Fill-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.904,7.9601375 C8.904,7.9601375 11.4200625,5.444075 13.0437125,3.820425 C13.78615,3.0779875 13.78615,1.87425 13.0437125,1.131725 C13.0291,1.1172 13.014575,1.102675 13.00005,1.0880625 C12.257525,0.345625 11.0537875,0.345625 10.31135,1.0880625 C8.6877,2.7117125 6.1716375,5.227775 6.1716375,5.227775 L8.904,7.9601375 Z",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.3050375,
    y1: 4.361175,
    x2: 9.7706,
    y2: 8.8267375,
    id: "Stroke-4",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnColorPicker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-color-picker.70abbc1e.svg";
export { ForwardRef as ReactComponent };